export default {
      id: "icon-pinterest-widget-usage",
      viewBox: "0 0 40 24",
      url: __webpack_public_path__ + "icons.svg#icon-pinterest-widget",
      toString: function () {
        return this.url;
      }
    }